/**
 * Core financial calculation logic for the Ashdale Analytics engine
 */

export const calculateRetirementProjection = (data) => {
  const {
    currentAge,
    retirementAge,
    currentSavings,
    monthlyContribution,
    annualReturn = 7,
    inflationRate = 3
  } = data;

  const yearsToRetirement = Math.max(0, parseInt(retirementAge) - parseInt(currentAge));
  const monthsToRetirement = yearsToRetirement * 12;
  const monthlyReturn = parseFloat(annualReturn) / 100 / 12;

  // Future value of current savings
  const futureValueSavings = parseFloat(currentSavings) * Math.pow(1 + monthlyReturn, monthsToRetirement);

  // Future value of annuity (monthly contributions)
  const futureValueContributions = monthsToRetirement > 0 
    ? parseFloat(monthlyContribution) * ((Math.pow(1 + monthlyReturn, monthsToRetirement) - 1) / monthlyReturn)
    : 0;

  const totalRetirementFund = futureValueSavings + futureValueContributions;

  // Purchasing power with inflation (Real Value)
  const realValue = totalRetirementFund / Math.pow(1 + parseFloat(inflationRate) / 100, yearsToRetirement);

  // Generate chart data for growth visualization
  const chartData = [];
  for (let year = 0; year <= yearsToRetirement; year++) {
    const months = year * 12;
    const sValue = parseFloat(currentSavings) * Math.pow(1 + monthlyReturn, months);
    const cValue = months > 0 ? parseFloat(monthlyContribution) * ((Math.pow(1 + monthlyReturn, months) - 1) / monthlyReturn) : 0;
    chartData.push({
      year: parseInt(currentAge) + year,
      value: Math.round(sValue + cValue)
    });
  }

  return {
    totalRetirementFund: Math.round(totalRetirementFund),
    realValue: Math.round(realValue),
    monthlyIncome: Math.round(totalRetirementFund / (25 * 12)), // 4% Rule
    chartData,
    inputs: data
  };
};

export const calculateAge = (dob) => {
  if (!dob) return 0;
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const normalizeToMonthly = (amount, frequency) => {
  const val = parseFloat(amount) || 0;
  switch (frequency) {
    case 'Yearly': return val / 12;
    case 'Bi-Annually': return val / 6;
    case 'Quarterly': return val / 3;
    case 'Monthly': return val;
    default: return val;
  }
};